import { Directive, TemplateRef } from '@angular/core';

/**
 * Represents the content template of the declaratively initialized PanelBar items.
 * The content can be expanded or collapsed through the item.
 */
@Directive({
  standalone: false,
  selector: '[kendoPanelBarContent]',
})
export class PanelBarContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
